import React from 'react';

import _ from 'lodash';
import * as queryString from 'query-string';
import { useLocation } from 'react-router-dom';



export function useStringQueryValue({
  key, fnPreProcess
}: {
  key: string;
  fnPreProcess?: (value: string) => string;
}) {
  const location = useLocation();

  const result = React.useMemo(() => {
    const parsedResult = fnPreProcess ? fnPreProcess(location.search) : location.search;
    const e = queryString.parse(parsedResult)[key] ?? '';
    if (_.isArray(e)) {
      return _.first(e) ?? '';
    }

    return e ?? '';
  }, [key, fnPreProcess, location]);

  return result;
}
